<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11eY3wl/tc-custom/9780823256518.jpg?1702841865440" alt="This image is the cover for the book For Strasbourg"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">For Strasbourg
      </h1>
      <p class="bookDescription body article font2">
        <b>The eminent philosopher pays homage to his beloved French city and the philosophical friendships he had there—“an illuminating addition to his legacy” (<i>The Times Literary Supplement</i>).</b><br/>  <br/> A towering figure in twentieth-century philosophy, Jacques Derrida was born in Algeria, but spent four decades living in the French city of Strasbourg, located on the border between France and Germany. This moving collection of writings and interviews about his life there opens with “The Place Name(s): Strasbourg,” an essay written just a month before his death which recounts his deep attachment to his adoptive home.<br/>  <br/> More than just a personal narrative, however, the essay is a profound interrogation of the relationship between philosophy and place, philosophy and language, and philosophy and friendship. As such, it raises a series of philosophical, political, and ethical questions that might all be placed under the aegis of what Derrida once called “philosophical nationalities and nationalism.”<br/>  <br/> Also included are transcribed conversations between Derrida and his two principal interlocutors in Strasbourg, Jean-Luc Nancy and Philippe Lacoue-Labarthe. These interviews are significant for the themes they focus on—from language and politics to friendship and life after death—and for what they reveal about Derrida’s relationships to Nancy and Lacoue-Labarthe. Filled with sharp insights into one another’s work and peppered with personal anecdotes and humor, the interviews bear witness to the long intellectual friendships of these three important thinkers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacques Derrida, Pascale-Anne Brault, Michael Naas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f2ed9fe